import React from 'react'
import { OpenStatus, usePopupAnimationOptions } from './usePopupAmimation.types'

type PopupAnimationTuple = Parameters<
  (n: OpenStatus, s: React.EventHandler<React.AnimationEvent>) => void
>

function usePopupAnimation(
  isOpened: boolean,
  { enterAnimationName, exitAnimationName }: usePopupAnimationOptions
): PopupAnimationTuple {
  const [openStatus, setOpenStatus] = React.useState<OpenStatus>('unmounted')

  const onAnimationEnd = React.useCallback(
    (e: React.AnimationEvent) => {
      if (openStatus === 'entering' && e.animationName === enterAnimationName) {
        setOpenStatus('mounted')
      }

      if (openStatus === 'exiting' && e.animationName === exitAnimationName) {
        setOpenStatus('unmounted')
      }
    },
    [openStatus, enterAnimationName, exitAnimationName]
  )

  React.useEffect(() => {
    if (isOpened && openStatus === 'unmounted') {
      setOpenStatus('entering')
    }

    if (!isOpened && openStatus === 'mounted') {
      setOpenStatus('exiting')
    }
  }, [isOpened, openStatus])

  return [openStatus, onAnimationEnd]
}

export default usePopupAnimation
